import * as React from 'react'

import moment from 'moment'
import {
  formatDateTime,
  formatDate,
  formatTimespan,
} from 'app/common/dateHelper'
import { WeeklyRestEventModel } from 'app/models/weeklyRestModel'
import { TooltipLayout } from './ToolTipLayout'

type WeeklRestTooltipProps = {
  weeklyRest: WeeklyRestEventModel
  translate: (text) => any
}
type WeeklRestTooltipState = {}

export class WeeklyRestTooltip extends React.Component<
  WeeklRestTooltipProps,
  WeeklRestTooltipState
> {
  constructor(props: WeeklRestTooltipProps) {
    super(props)
  }

  private getDisplayEndTime = (weeklyRest: WeeklyRestEventModel): any => {
    const displayDuration =
      weeklyRest.restDuration ?? weeklyRest.formalRestDuration

    if (displayDuration == null) {
      return weeklyRest.realRestEndTime ?? (weeklyRest as any).endTime
    }

    const dur = moment.duration(displayDuration)
    const ms = dur.asMilliseconds()

    if (isNaN(ms)) {
      return weeklyRest.realRestEndTime ?? (weeklyRest as any).endTime
    }

    return moment(weeklyRest.startTime).clone().add(dur)
  }

  render() {
    const {
      startTime,
      typeName,
      formalRestEndDate,
      firstDayOfWeekTheRestBelongsTo,
      color,
    } = this.props.weeklyRest

    const displayDuration =
      this.props.weeklyRest.restDuration ?? this.props.weeklyRest.formalRestDuration
    const durationValue =
      displayDuration != null ? formatTimespan(displayDuration) : '--:--'
    const displayEndTime = this.getDisplayEndTime(this.props.weeklyRest)

    const rows = [
      {
        title: this.props.translate('event.duration'),
        value: durationValue,
      },
      {
        title: this.props.translate('event.startTime'),
        value: formatDateTime(startTime),
      },
      {
        title: this.props.translate('event.endTime'),
        value: formatDateTime(displayEndTime),
      },
      {
        title: this.props.translate('event.firstDayOfWeek'),
        value: formatDate(firstDayOfWeekTheRestBelongsTo),
      },
    ]

    return (
      <TooltipLayout
        headerColor={color}
        headerTitle={this.props.translate(typeName).toString()}
        rows={rows}
      />
    )
  }
}
